import { render } from "./Presenze.vue?vue&type=template&id=3659dade&scoped=true"
import script from "./Presenze.vue?vue&type=script&lang=js"
export * from "./Presenze.vue?vue&type=script&lang=js"

import "./Presenze.vue?vue&type=style&index=0&id=3659dade&scoped=true&lang=css"

import exportComponent from "/Users/andrea/Sites/app_v2/app_seilatv/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3659dade"]])

export default __exports__